module.exports = __webpack_public_path__ + "img/00de5cd.png";